import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';

export default DownloadRoundedIcon;
